import { Text } from '@mantine/core';
import clsx from 'clsx';

import { SORTABLE_GROUPING_ITEM_CLASS_NAME } from '../../utils/constants';
import { Button } from '../buttons/Button';
import { Checkbox } from '../checkbox/Checkbox';
import { GoogleFontIcon } from '../icons/GoogleFontIcon';
import { SVGIcon } from '../icons/SVGIcon';

import { TableColumnSettings } from './TableCustomizationModal';

import styles from './table-customization.module.scss';

export type TableCustomizationItemProps = TableColumnSettings & {
  onChange: (id: string, isVisible: boolean) => void;
  onGroupByClick?: (id: string) => void;
  showSortingHandle?: boolean;
  isGroupingSectionLocked?: boolean;
};

export function TableCustomizationItem({
  id,
  label,
  isGroupingSectionLocked,
  isVisible,
  isGroupable = false,
  onChange,
  onGroupByClick,
  sublabel,
  showSortingHandle = true,
  disabled = false,
}: TableCustomizationItemProps) {
  const onClick = () => {
    if (!onGroupByClick || isGroupingSectionLocked || !isGroupable) {
      return;
    }
    onGroupByClick(id);
  };
  return (
    <div
      className={clsx(
        styles['item'],
        showSortingHandle && styles['item--sortable'],
        isGroupable && SORTABLE_GROUPING_ITEM_CLASS_NAME
      )}
    >
      <div
        className={styles['item__left']}
        onClick={() => onChange(id, !isVisible)}
      >
        <Checkbox disabled={disabled} checked={isVisible} />
      </div>
      <div className={styles['item__right']}>
        <Text
          classNames={{ root: styles['item__text'] }}
          onClick={() => onChange(id, !isVisible)}
        >
          {label}
          {sublabel && (
            <span className={styles['item__text__sublabel']}>{sublabel}</span>
          )}
        </Text>
        {isGroupable && (
          <Button
            disabled={isGroupingSectionLocked}
            icon={<SVGIcon name="groupBy" />}
            onClick={onClick}
            title="Group by"
            variant="text"
          />
        )}
        {showSortingHandle && (
          <GoogleFontIcon
            className={styles['item__reorder-symbol']}
            name="reorder"
          />
        )}
      </div>
    </div>
  );
}
